import React from 'react';
import { Link } from 'react-router-dom';
import WaitlistForm from './WaitlistForm';

// ---- Icon set (matches the design's "FI" vocabulary) ----
export const FI = {
  arrowR: <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7h9M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  arrowL: <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M12 7H3M7 3L3 7l4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  check: <svg width="11" height="11" viewBox="0 0 14 14" fill="none"><path d="M2.5 7l3 3 6-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  voice: <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 7v4M6.5 4.5v9M10 6v6M13.5 4v10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>,
  flow: <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="2" y="3" width="6" height="4.5" rx="1.2" stroke="currentColor" strokeWidth="1.7" /><rect x="10" y="10.5" width="6" height="4.5" rx="1.2" stroke="currentColor" strokeWidth="1.7" /><path d="M8 5.2h3a2 2 0 012 2v3.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" /></svg>,
  gauge: <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 13a6 6 0 1112 0" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" /><path d="M9 13l3.5-3.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" /></svg>,
  eye: <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 9s2.8-5 7-5 7 5 7 5-2.8 5-7 5-7-5-7-5z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" /><circle cx="9" cy="9" r="2" stroke="currentColor" strokeWidth="1.7" /></svg>,
  sliders: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 4h6M11 4h2M3 12h2M7 12h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><circle cx="10" cy="4" r="1.6" stroke="currentColor" strokeWidth="1.6" /><circle cx="6" cy="12" r="1.6" stroke="currentColor" strokeWidth="1.6" /></svg>,
  lock: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.6" /><path d="M5 7V5a3 3 0 016 0v2" stroke="currentColor" strokeWidth="1.6" /></svg>,
  ai: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 2l1.5 3.5L13 7l-3.5 1.5L8 12l-1.5-3.5L3 7l3.5-1.5L8 2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" /></svg>,
  layers: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 2l6 3-6 3-6-3 6-3zM2 8l6 3 6-3M2 11l6 3 6-3" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" /></svg>,
  bolt: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M9 2L3 9h4l-1 5 6-7H8l1-5z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /></svg>,
  alert: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 2l6 11H2L8 2zM8 7v3M8 11.5v.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  search: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="4" stroke="currentColor" strokeWidth="1.6" /><path d="M10.5 10.5L14 14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  history: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.6" /><path d="M8 5v3l2 1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  device: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="2" y="3" width="8" height="10" rx="1.4" stroke="currentColor" strokeWidth="1.5" /><rect x="11" y="6" width="3.5" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" /></svg>,
};

// ---- Cross-feature catalogue (keys map to URL slugs) ----
export const FD_CATALOG = {
  'brand-voice': { key: 'brand-voice', tint: '', icon: FI.voice, title: 'Brand voice', href: '/features/brand-voice', blurb: 'Tone, form of address, and forbidden terms the AI actually follows.' },
  'automations': { key: 'automations', tint: 'indigo', icon: FI.flow, title: 'Automations', href: '/features/automations', blurb: 'Translate on every PR, route by language, deliver at 100%.' },
  'ai-quality': { key: 'ai-quality', tint: 'green', icon: FI.gauge, title: 'AI quality', href: '/features/ai-quality', blurb: 'A quality estimate and risk flags on every draft, before review.' },
  'preview': { key: 'preview', tint: 'yellow', icon: FI.eye, title: 'Catch broken layouts', href: '/features/preview', blurb: 'Translations in the real UI, with live overflow warnings.' },
  'layout-risk': { key: 'layout-risk', tint: '', icon: FI.alert, title: 'Pre-flight layout risk', href: '/features/layout-risk', blurb: 'Predict which frames overflow before you translate — then Auto-fit them.' },
};
export const FD_ORDER = ['brand-voice', 'automations', 'ai-quality', 'preview', 'layout-risk'];

export const FeatHero = ({ tint, kicker, kickerIcon, title, lead, primary, secondary, meta, visual }) => (
  <section className="fd-hero">
    <div className="hero-mesh"></div>
    <div className="rs-container">
      <div className="fd-hero-grid">
        <div className="fd-hero-copy hero-anim">
          <Link className="fd-back" to="/#pricing">{FI.arrowL} What sets us apart</Link>
          <div className="fd-kicker">
            <span className={`fd-kicker-ic ${tint || ''}`}>{kickerIcon}</span>
            <span className="fd-kicker-txt">{kicker}</span>
          </div>
          <h1 className="fd-h1">{title}</h1>
          <p className="fd-lead">{lead}</p>
          <div className="fd-hero-cta">
            {primary && (primary.to ? <Link className="btn btn-accent btn-lg" to={primary.to}>{primary.label}</Link> : <a className="btn btn-accent btn-lg" href={primary.href}>{primary.label}</a>)}
            {secondary && (secondary.to ? <Link className="btn btn-ghost btn-lg" to={secondary.to}>{secondary.label}</Link> : <a className="btn btn-ghost btn-lg" href={secondary.href}>{secondary.label}</a>)}
          </div>
          {meta && (
            <div className="fd-hero-meta">
              {meta.map((m) => (
                <span key={m} className="fd-hero-meta-item"><span className="tick">{FI.check}</span>{m}</span>
              ))}
            </div>
          )}
        </div>
        <div className="fd-hero-visual reveal reveal-scale">{visual}</div>
      </div>
    </div>
  </section>
);

export const FeatCapabilities = ({ tint, eyebrow, title, lead, caps }) => (
  <section className="fd-band">
    <div className="rs-container">
      <div className="fd-band-head reveal">
        <div className="eyebrow">{eyebrow}</div>
        <h2>{title}</h2>
        {lead && <p>{lead}</p>}
      </div>
      <div className="fd-caps stagger">
        {caps.map((c) => (
          <div className="fd-cap" key={c.title}>
            <div className={`fd-cap-ic ${tint || ''}`}>{c.icon}</div>
            <h3>{c.title}</h3>
            <p>{c.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const FeatDetailRow = ({ reverse, eyebrow, title, intro, points, replaces, visual, soft }) => (
  <section className={`fd-band ${soft ? 'soft' : ''}`}>
    <div className="rs-container">
      <div className={`feat-grid ${reverse ? 'reverse' : ''}`}>
        <div className="feat-copy reveal">
          <div className="eyebrow">{eyebrow}</div>
          <h2 className="feat-title">{title}</h2>
          <p className="feat-intro">{intro}</p>
          {points && (
            <div className="feat-sublist">
              {points.map((p) => (
                <div className="feat-sub" key={p.title}>
                  <div className="feat-sub-icon">{p.icon}</div>
                  <div><div className="feat-sub-title">{p.title}</div><div className="feat-sub-desc">{p.desc}</div></div>
                </div>
              ))}
            </div>
          )}
          {replaces && (
            <div className="feat-replaces">
              <span className="feat-replaces-label">Replaces</span>
              <span className="feat-replaces-tags">{replaces.map((r) => <span className="feat-replace-tag" key={r}>{r}</span>)}</span>
            </div>
          )}
        </div>
        <div className="feat-visual reveal reveal-scale">{visual}</div>
      </div>
    </div>
  </section>
);

export const FeatSteps = ({ eyebrow, title, steps }) => (
  <section className="fd-band soft">
    <div className="rs-container">
      <div className="fd-band-head reveal">
        <div className="eyebrow">{eyebrow}</div>
        <h2>{title}</h2>
      </div>
      <div className="fd-steps stagger">
        {steps.map((s, i) => (
          <div className="fd-step" key={s.h}>
            <div className="fd-step-n">{i + 1}</div>
            <h4>{s.h}</h4>
            <p>{s.p}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const FeatQuote = ({ quote, initials, name, role }) => (
  <section className="fd-band">
    <div className="rs-container">
      <div className="fd-quote reveal">
        <blockquote>{quote}</blockquote>
        <div className="fd-quote-author">
          <span className="fd-quote-avatar">{initials}</span>
          <span className="who"><b>{name}</b><span>{role}</span></span>
        </div>
      </div>
    </div>
  </section>
);

export const FeatCrossLinks = ({ current }) => {
  const others = FD_ORDER.filter((k) => k !== current).map((k) => FD_CATALOG[k]);
  return (
    <section className="fd-band soft">
      <div className="rs-container">
        <div className="fd-band-head center reveal">
          <div className="eyebrow">Keep exploring</div>
          <h2>The rest of what sets us apart.</h2>
        </div>
        <div className="fd-cross-grid stagger">
          {others.map((o) => (
            <Link className="fd-cross-card" key={o.key} to={o.href}>
              <div className={`fd-cross-ic ${o.tint}`}>{o.icon}</div>
              <h3>{o.title}</h3>
              <p>{o.blurb}</p>
              <span className="fd-cross-go">Learn more {FI.arrowR}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export const FeatFinalCTA = ({ title, sub, source = 'feature-final' }) => (
  <section className="section">
    <div className="rs-container">
      <div className="final-cta reveal reveal-scale">
        <h2>{title}</h2>
        <p>{sub}</p>
        <WaitlistForm source={source} />
      </div>
    </div>
  </section>
);
